export const formatUserRole = (role) => {
    return {
      upper: role.toUpperCase(),
      lower: role.toLowerCase(),
      capitalize: role.charAt(0).toUpperCase() + role.slice(1)
    };
  };